import { createStore } from "vuex";
import auth, { AuthState } from "./modules/auth";

export interface State {
  auth: AuthState;
}

export default createStore<State>({
  modules: {
    auth,
  },
});
